import { html } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/mixin';
export const navTemplate = html `<template role="navigation"><slot></slot></template>`;
export class NavComponent extends ChameleonElementMixin(FoundationElement) {
}
